function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var equal = _interopDefault(require('react-fast-compare'));

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
/* tslint:disable */


var runtime = require('file-loader?name=apicurio-runtime.js!@syndesis/apicurio-assembly/dist/apicurio/runtime.js');

var polyfills = require('file-loader?name=apicurio-polyfills.js!@syndesis/apicurio-assembly/dist/apicurio/polyfills.js');

var styles = require('file-loader?name=apicurio-styles.js!@syndesis/apicurio-assembly/dist/apicurio/styles.js');

var scripts = require('file-loader?name=apicurio-scripts.js!@syndesis/apicurio-assembly/dist/apicurio/scripts.js');

var vendor = require('file-loader?name=apicurio-vendor.js!@syndesis/apicurio-assembly/dist/apicurio/vendor.js');

var main = require('file-loader?name=apicurio-main.js!@syndesis/apicurio-assembly/dist/apicurio/main.js');

var ApicurioAdapter =
/*@__PURE__*/
function (superclass) {
  function ApicurioAdapter(props) {
    superclass.call(this, props);
    this.iframe = null;
    this.messageChannel = new MessageChannel();
    this.onIframeLoad = this.onIframeLoad.bind(this);
    this.onMessages = this.onMessages.bind(this);
  }

  if (superclass) ApicurioAdapter.__proto__ = superclass;
  ApicurioAdapter.prototype = Object.create(superclass && superclass.prototype);
  ApicurioAdapter.prototype.constructor = ApicurioAdapter;

  ApicurioAdapter.prototype.componentDidMount = function componentDidMount() {
    if (this.iframe) {
      this.iframe.addEventListener('load', this.onIframeLoad);
    }
  };

  ApicurioAdapter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var ref = this.props;
    var rest = objectWithoutProperties(ref, ["onSpecification"]);
    var prevPayload = rest;
    var rest$1 = objectWithoutProperties(nextProps, ["onSpecification"]);
    var nextPayload = rest$1;

    if (!equal(prevPayload, nextPayload)) {
      this.updateApicurioApp(nextPayload);
    }
  };

  ApicurioAdapter.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  ApicurioAdapter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.iframe) {
      this.iframe.removeEventListener('load', this.onIframeLoad);
    }
  };

  ApicurioAdapter.prototype.onIframeLoad = function onIframeLoad() {
    this.messagePort = this.messageChannel.port1;
    this.messagePort.onmessage = this.onMessages;
    this.iframe.contentWindow.postMessage('init', '*', [this.messageChannel.port2]);
  };

  ApicurioAdapter.prototype.onMessages = function onMessages(event) {
    switch (event.data.message) {
      case 'ready':
        {
          var ref = this.props;
          var rest = objectWithoutProperties(ref, ["onSpecification"]);
          var payload = rest;
          this.updateApicurioApp(payload);
          break;
        }

      case 'specification':
        {
          var payload$1 = event.data.payload;
          this.props.onSpecification(payload$1.specification);
          break;
        }
    }
  };

  ApicurioAdapter.prototype.updateApicurioApp = function updateApicurioApp(payload) {
    if (this.messagePort) {
      var message = {
        message: 'update',
        payload: payload
      };
      this.messagePort.postMessage(message);
    }
  };

  ApicurioAdapter.prototype.render = function render() {
    var this$1 = this;
    var srcDoc = "<!doctype html>\n<html lang=\"en\">\n<head>\n  <meta charset=\"utf-8\">\n  <title>Apicurio</title>\n  <base href=\"/dm\">\n\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n  <link rel=\"icon\" type=\"image/x-icon\" href=\"favicon.ico\">\n</head>\n<body style=\"background: transparent;\">\n  <app-root></app-root>\n  <script type=\"text/javascript\" src=\"" + runtime + "\"></script>\n  <script type=\"text/javascript\" src=\"" + polyfills + "\"></script>\n  <script type=\"text/javascript\" src=\"" + styles + "\"></script>\n  <script type=\"text/javascript\" src=\"" + scripts + "\"></script>\n  <script type=\"text/javascript\" src=\"" + vendor + "\"></script>\n  <script type=\"text/javascript\" src=\"" + main + "\"></script></body>\n</html>\n\n"; // bypass some odd typing incompatibility with base React when using "exotic"
    // html attributes

    var extraProps = {
      allowtransparency: ''
    };
    return React.createElement("iframe", Object.assign({
      name: 'apicurio-frame',
      srcDoc: srcDoc,
      style: {
        width: '100%',
        height: '100%',
        lineHeight: '0'
      },
      frameBorder: 0
    }, extraProps, {
      ref: function ref(el) {
        return this$1.iframe = el;
      }
    }));
  };

  return ApicurioAdapter;
}(React.Component);

exports.ApicurioAdapter = ApicurioAdapter;